
import actions from './actions.js';
import mutations from './mutations.js';
import state from './state.js';
import Store from './store.js';

// Merge auth actions with existing actions
const combinedActions = {
  ...actions
};

export default new Store({
  actions: combinedActions,
  mutations,
  state: {
    ...state,
    loading: false,
    error: null
  }
});